// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__25EOP","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1JCKH","obliqueLine":"membershipbadge_obliqueLine__2x4g2"};